export enum ReducerKeys {
  AUTH_SLICE = 'authSlice',
  MASTER_SLICE = 'masterSlice',
  NOTICE_SLICE = 'noticeSlice',
  SEARCH_SLICE = 'searchSlice',
  SECRETS_SLICE = 'secretsSlice'
}
